// The standalone users table is a Key/Value store (team id -> JSON array of
// users), so chart SQL cannot join it directly. Build a chart_users(id,
// displayName) lookup table from team_users.Users instead — the same source
// TeamAssignmentDialog and TotalAndAssignedCards already parse successfully.
const usersTablePromises = new WeakMap();

export const ensureChartUsersTable = (conn) => {
  if (!usersTablePromises.has(conn)) {
    usersTablePromises.set(conn, (async () => {
      const result = await conn.query('SELECT Id, Users FROM team_users');
      const seen = new Map();
      result.toArray().forEach(row => {
        const team = row.toJSON();
        let users = team.Users || team.users || [];
        if (typeof users === 'string') {
          try { users = JSON.parse(users); } catch { users = []; }
        }
        if (users && typeof users.toArray === 'function') {
          users = users.toArray().map(u => (typeof u.toJSON === 'function' ? u.toJSON() : u));
        }
        if (Array.isArray(users)) {
          users.forEach(u => {
            const id = u.Id || u.id;
            if (id && !seen.has(id)) {
              seen.set(id, u.DisplayName || u.displayName || String(id));
            }
          });
        }
      });

      await conn.query(`
        DROP TABLE IF EXISTS chart_users;
        CREATE TEMPORARY TABLE chart_users(id VARCHAR, displayName VARCHAR);
      `);
      const values = [...seen.entries()]
        .map(([id, name]) => `('${String(id).replace(/'/g, "''")}', '${String(name).replace(/'/g, "''")}')`)
        .join(',');
      if (values) {
        await conn.query(`INSERT INTO chart_users VALUES ${values}`);
      }
    })());
  }
  return usersTablePromises.get(conn);
};
